module.exports = {
      id: "hamburger-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#hamburger",
      toString: function () {
        return this.url;
      }
    }